// extracted by mini-css-extract-plugin
export default {"content":"DeleteTokenModal-module__content","description":"DeleteTokenModal-module__description"};